export default "/images/coins.svg?a478ce97f96a634fbf041f8db072d3d2";